import { Variants } from 'motion/react';

type LoadingAnimationProps = {
  delayMultiplier: number; // Multiplier to calculate delay based on widget position
};

export const WIDGET_LOADING_VARIANTS: Variants = {
  hidden: { opacity: 0, y: 10 },
  visible: ({ delayMultiplier }: LoadingAnimationProps) => ({
    opacity: 1,
    y: 0,
    transition: { delay: delayMultiplier * 0.1, duration: 0.5 },
  }),
};
